<template>
  <div class="d-flex">
    <div class="mx-1 navbar-collapse flex justify-content-end collapse order-4 order-md-2" id="user-dropdown">
        <ul class="navbar-nav flex-row ">
            <li class="nav-item">
                <a class="nav-link" :href="routes.DASHBOARD">Dashboard</a>
            </li>
            <li class="nav-item">
                <a class="nav-link btn-logout" @click="signOut" href="javascript:void(0)">Sign Out</a>
            </li>
        </ul>
    </div>
    <div class="mx-1 nav-item order-2 order-md-3">
        <BellNotification ref="bell"></BellNotification>
    </div>
    <button class="ml-1 navbar-toggler d-md-flex order-3 order-md-4"
            type="button" data-toggle="collapse" data-target="#user-dropdown"
            aria-controls="user-dropdown" aria-expanded="false" aria-label="Toggle user dropdown">
        <span class="p-1 fa fa-bars"></span>
    </button>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from "vue-facing-decorator";
import BellNotification from './BellNotification.vue';
import {signOut} from '../auth/Auth';
import {Dashboard} from '../Routes';


@Component({
  components: {BellNotification}
})
export default class UserWidget extends Vue {
  public $refs!: {
    bell: BellNotification
  }
  private routes = {
    DASHBOARD: Dashboard.url
  }
  private signOut() {
    signOut();
  }
}
</script>
